<template>
  <div class="meetings-list">
    <h1>{{title}},{{time}},{{city}}站活动</h1>
    <h2>累计报名人数:{{count}}</h2>
    <div class="excel">
      <el-button @click='getExcel'>
        下载已报名用户数据
      </el-button>
    </div>
    <el-table :data='tableShow' :row-key="getRowKeys">
      <el-table-column prop='id' label='参会人ID' />
      <el-table-column prop='person' label='姓名' />
      <el-table-column prop='company' label='公司名' />
      <el-table-column prop='position' label='职位' />
      <el-table-column prop='phoneNum' label='手机号' />
      <el-table-column prop='email' label='邮箱' />
      <!-- <el-table-column prop='stockCode' label='股票代码' /> -->
      <el-table-column prop='card' label='名片'>
        <template slot-scope='scope'>
          <el-popover ref="scope" width="500" trigger="hover" placement="left-start" offset=12>
            <img :src="scope.row.card" width="100%">
            <el-button slot="reference" type="text">
              <a :href="scope.row.card" target="_blank"> 查看名片</a>
            </el-button>
          </el-popover>
        </template>
      </el-table-column>
      
      <el-table-column prop='smsS' label='短信' :filters="[{ text: '已发送', value: 'send' }, { text: '未发送', value: 'not' }]">
        <template slot-scope='scope'>
          <span v-if='scope.row.smsS=="send"' class="need-passed">已发送</span>
          <span v-else class="need-pass"> 未发送 </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="normal-pagination">
      <el-pagination layout="total, prev, pager, next" :page-size="8" :total="total" style="float:right" @current-change='changePage'>
      </el-pagination>
    </div>
    <el-button type="danger" round @click='sendNotice' :disabled='buttonStatus'>给当前页发送提醒</el-button>
    
  </div>
</template>
<script>
import moment from "moment";
import axios from "axios";
export default {
  data() {
    return {
      tableShow: [],
      tableData: [],
      page: 1,
      count: 0,
      passed: 0,
      rejected: 0,
      city: null,
      title: null,
      time: 0,
      send: 0,
      notsend: 0,
      buttonStatus: false
    };
  },
  methods: {
    getUserList(acid) {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      axios
        .post("/acapi/ac/estateforum_ticket/get_person_list", { acid })
        .then(res => {
          loading.close();
          if (res.data.statusCode === 200) {
            this.tableData = res.data.result;
            this.count = res.data.result.length;
            this.changePage(this.page);
          } else {
            this.$message.error("请求数据失败," + res.data.message);
          }
        });
    },
    getCityInfo(id) {
      this.$http.estateforum_findbyid({ id }).then(res => {
        if (res.data.statusCode === 200) {
          this.city = res.data.result.city;
          this.title = res.data.result.title;
        }
      });
    },
    getRowKeys(row) {
      return row.id;
    },
    getExcel() {
      console.log("查询数据excel数据");
      window.open(`/acapi/ac/estateforum_ticket/getExcel/${this.acid}`);
    },
    //给已审核用户发送参会提醒
    sendNotice() {
      this.buttonStatus = true;
      const users = this.tableShow;
      console.log(users);
      if (users.length === 0) {
        this.$notify({
          title: "警告",
          message: "当前页面无未发送短信提醒用户(‾⌣‾ԅ)",
          type: "warning"
        });
        this.buttonStatus = false;
        return;
      }
      const result = users.map(item => {
        const { id, phoneNum } = item;
        return axios.post("/acapi/ac/estateforum_ticket/send_sms", {
          phoneNum,
          id
        });
      });

      Promise.all([...result]).then(res => {
        const count = res.filter(item => item.data.statusCode === 200);
        console.log(count);
        this.$notify({
          message: "发送短信成功~,成功数量" + count.length,
          type: "success",
          position: "bottom-right",
          duration: 0
        });
        this.getUserList(this.acid);
        this.buttonStatus = false;
        this.changePage(this.page);
      });
    },
    changePage(id) {
      this.page = id;
      const start = (id - 1) * 8;
      const end = start + 8;
      this.tableShow = this.tableData.slice(start, end);
    }
  },

  computed: {
    acid() {
      return this.$route.params.acid;
    },
    total() {
      return this.tableData.length;
    }
  },
  mounted() {
    this.getUserList(this.acid);
    this.getCityInfo(this.acid);
  }
};
</script>

<style scoped>
.need-pass {
  color: #fa5555;
}

.need-passed {
  color: #67c23a;
}

.need-failed {
  color: #878d99;
}

.normal-pagination {
  overflow: hidden;
}

.send-all-user-container {
  float: right;
  padding: 20px 0;
}

.meetings-list h1,
.meetings-list h2 {
  font-size: 16px;
  font-weight: normal;
  padding: 5px;
}
.excel {
  position: absolute;
  top: 20px;
  right: 20px;
}
.normal-pagination {
  overflow: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/estateforum/estateforum_users.vue